import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import { utils, writeFileXLSX } from "xlsx";
import { useReportProductDoInitContext } from "contexts/reportProductDoPage/ReportProductDoInitContext";
import { Formik } from "formik";
import BranchMultiSelected from "fragments/BranchMultiSelected";
import ReportProductDoModalGroup from "./ReportProductDoModalGroup";
import { Box } from "@mui/material";
import ReportProductDoTable from "./ReportProductDoTable";
import usePageLoadingSync from "hooks/usePageLoadingSync";
import CustomDateRange from "fragments/CustomDateRange";
export function ReportProductDoContent() {
    var _useReportProductDoInitContext = useReportProductDoInitContext(), formData = _useReportProductDoInitContext.formData, options = _useReportProductDoInitContext.options, modalReportProductDoState = _useReportProductDoInitContext.modalReportProductDoState, branchMultiSelected = _useReportProductDoInitContext.branchMultiSelected, setBranchMultiSelected = _useReportProductDoInitContext.setBranchMultiSelected, schema = _useReportProductDoInitContext.schema, formReportProductDoState = _useReportProductDoInitContext.formReportProductDoState, isInitReportProductDoLoading = _useReportProductDoInitContext.isInitReportProductDoLoading, setReportDate = _useReportProductDoInitContext.setReportDate, tableData = _useReportProductDoInitContext.tableData;
    var modalProductSelect = modalReportProductDoState.modalProductSelect, setModalProductSelect = modalReportProductDoState.setModalProductSelect;
    var isFormReportProductDoLoading = formReportProductDoState.isFormReportProductDoLoading, handleMainSubmit = formReportProductDoState.handleMainSubmit;
    // const handlePrint = useReactToPrint({ contentRef });
    usePageLoadingSync({
        loadingStates: [
            isInitReportProductDoLoading,
            isFormReportProductDoLoading
        ]
    });
    return /*#__PURE__*/ _jsxs("div", {
        className: "pagezoom",
        children: [
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx("nav", {
                    "aria-label": "breadcrumb",
                    className: "mt-2 mb-4",
                    children: /*#__PURE__*/ _jsxs("ol", {
                        className: "breadcrumb fs-16 ps-0",
                        children: [
                            /*#__PURE__*/ _jsx("li", {
                                className: "breadcrumb-item ",
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: "#",
                                    className: "tc-7  text-decoration-none",
                                    children: "รายงาน"
                                })
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                className: "breadcrumb-item ",
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: "#",
                                    className: "tc-7  text-decoration-none",
                                    children: "รายงานคลังสินค้า"
                                })
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                className: "breadcrumb-item active tc-1 ",
                                "aria-current": "page",
                                children: "รายงานยอดขายรายสินค้า จาก DO"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "fs-24",
                children: "รายงานยอดขายรายสินค้า จาก DO"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "card card-st-2 mt-[20px] mb-4",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "card-body px-0 pt-4 pb-0",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "mb-2 fs-16 text-[#4C4E64]/[0.87] font-semibold text-lg px-4",
                                    children: "ตัวเลือกการค้นหา"
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "bg-[rgba(244,195,100,0.29)] flex justify-center items-center rounded-[8px] gap-[10px] p-[10px]",
                                    children: [
                                        /*#__PURE__*/ _jsx("img", {
                                            className: "w-[15px] h-[15px]",
                                            src: "/images/icon-alert-warn-orange.png",
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "fs-14 font-semibold tc-8",
                                            children: "รายงานรวมข้อมูลการคืนสินค้า"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Formik, {
                            enableReinitialize: true,
                            initialValues: formData,
                            validationSchema: schema,
                            onSubmit: function(values) {
                                setBranchMultiSelected(options.branch.filter(function(v) {
                                    return values.dimBranchIDList.includes(v.value);
                                }));
                                setReportDate({
                                    startDate: values.startDate,
                                    endDate: values.endDate
                                });
                                handleMainSubmit({
                                    values: values
                                });
                            },
                            children: function(param) {
                                var handleSubmit = param.handleSubmit, handleChange = param.handleChange, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue, setErrors = param.setErrors, setValues = param.setValues, resetForm = param.resetForm;
                                return /*#__PURE__*/ _jsxs(Form, {
                                    noValidate: true,
                                    onSubmit: handleSubmit,
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "d-flex align-items-center px-4 mb-0 flex-wrap mt-[20px]",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "w-[300px] mr-4",
                                                    children: /*#__PURE__*/ _jsx(CustomDateRange, {})
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "mb-2 me-3 w-[300px]",
                                                    children: /*#__PURE__*/ _jsx(BranchMultiSelected, {
                                                        options: options.branch,
                                                        fieldname: "dimBranchIDList"
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "flex gap-[30px] mr-5",
                                                    children: [
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "flex gap-[10px]",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Form.Check, {
                                                                    id: "is-all-product-1",
                                                                    name: "isAllProduct",
                                                                    type: "radio",
                                                                    className: "",
                                                                    isInvalid: !!errors.isAllProduct,
                                                                    checked: values.isAllProduct,
                                                                    onChange: function() {
                                                                        setFieldValue("isAllProduct", true);
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ _jsx("label", {
                                                                    htmlFor: "is-all-product-1",
                                                                    className: "tc-7 fs-16",
                                                                    children: "สินค้าทั้งหมด"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "flex gap-[10px]",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Form.Check, {
                                                                    id: "is-all-product-2",
                                                                    name: "isAllProduct",
                                                                    type: "radio",
                                                                    className: "",
                                                                    isInvalid: !!errors.isAllProduct,
                                                                    checked: !values.isAllProduct,
                                                                    onChange: function() {
                                                                        setFieldValue("isAllProduct", false);
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ _jsx("label", {
                                                                    htmlFor: "is-all-product-2",
                                                                    className: "tc-7 fs-16",
                                                                    children: "ระบุสินค้า"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "flex gap-[20px]",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Button, {
                                                            onClick: function(e) {
                                                                setModalProductSelect(function(prev) {
                                                                    return _object_spread_props(_object_spread({}, prev), {
                                                                        open: true
                                                                    });
                                                                });
                                                            },
                                                            className: "btn btn-st-7 mb-2 px-4 min-w-[178px]",
                                                            disabled: values.isAllProduct,
                                                            children: values.dimProductPriceIDList.length > 0 ? "เลือกไว้ ".concat(values.dimProductPriceIDList.length, " รายการ") : "เลือกสินค้า"
                                                        }),
                                                        /*#__PURE__*/ _jsx(Button, {
                                                            type: "submit",
                                                            className: "btn btn-st-7 mb-2 px-4",
                                                            children: "ค้นหา"
                                                        }),
                                                        /*#__PURE__*/ _jsx(Button, {
                                                            onClick: function() {
                                                                resetForm();
                                                            },
                                                            className: "btn btn-st-7 mb-2 px-4 bg-[#FF0000]",
                                                            children: "ล้างการค้นหา"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(ReportProductDoModalGroup, {})
                                    ]
                                });
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "card card-st-2",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "card-body px-0 pt-4 pb-0",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "d-flex align-items-center px-4 mb-3 flex-wrap",
                            children: /*#__PURE__*/ _jsx(Box, {
                                sx: {
                                    width: "100%"
                                },
                                children: /*#__PURE__*/ _jsx(ReportProductDoTable, {
                                    data: tableData,
                                    branchMultiSelected: branchMultiSelected
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "py-4"
                    })
                ]
            })
        ]
    });
}
